import { render, staticRenderFns } from "./LastNews.vue?vue&type=template&id=6778f8cc&scoped=true"
import script from "./LastNews.ts?vue&type=script&lang=ts&external"
export * from "./LastNews.ts?vue&type=script&lang=ts&external"
import style0 from "./LastNews.vue?vue&type=style&index=0&id=6778f8cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6778f8cc",
  null
  
)

export default component.exports